const logToConsole = (opts) => {
  const method = opts.method.toUpperCase()

  const logs = [
    `%c[request] %c${method} /${opts.endpoint}`,
    'color: #9102e5;',
    'font-weight: bold; color: #9102e5;',
  ]

  console.log(...logs)

  if (opts.isGraphQL) {
    console.groupCollapsed('query')
    console.log(opts.body.query)
    console.groupEnd()

    if (opts.body.variables) {
      console.groupCollapsed('variables')
      console.log(opts.body.variables)
      console.groupEnd()
    }
  }
  else {
    if (opts.query) {
      console.groupCollapsed('query')
      console.log(opts.query)
      console.groupEnd()
    }
    if (opts.body) {
      console.groupCollapsed('body')
      console.log(opts.body)
      console.groupEnd()
    }
  }
}


export default logToConsole
